import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AppPasswordsPanel } from "@/components/AppPasswordsPanel";
import { AuthGate } from "@/components/AuthGate";
import { LanguagePanel } from "@/components/LanguagePanel";
import { NotificationsPanel } from "@/components/NotificationsPanel";
import { OfficeOpenPanel } from "@/components/OfficeOpenPanel";
import { PasskeysPanel } from "@/components/PasskeysPanel";
import { SessionsPanel } from "@/components/SessionsPanel";
import { TotpEnrollPanel } from "@/components/TotpEnrollPanel";
import { UsernamePanel } from "@/components/UsernamePanel";

export const Route = createFileRoute("/security")({
  component: function SecurityPage() {
    const { t } = useTranslation();
    return (
      <AuthGate>
        <div className="mx-auto max-w-2xl space-y-8">
          <h1 className="text-xl font-semibold">
            {t("security.title", "Security")}
          </h1>
          <UsernamePanel />
          <div className="border-t" />
          <LanguagePanel />
          <OfficeOpenPanel />
          <div className="border-t" />
          <NotificationsPanel />
          <div className="border-t" />
          <TotpEnrollPanel />
          <div className="border-t" />
          <PasskeysPanel />
          <div className="border-t" />
          <SessionsPanel />
          <div className="border-t" />
          <AppPasswordsPanel />
        </div>
      </AuthGate>
    );
  },
});
